import { ResponseType } from "../../Types/ServicesType/servicesType";
import {  saveUserGrpType, searchParamsType, UserListType } from "./type";
import api from "@services/apiList";
import instance from "@services/services";
const {SettingsApi} = api
export const getAllUsergrp = async (params:searchParamsType):Promise<ResponseType<{totalCount:number,items:UserListType[]}>>=>{
    const result = await instance.post(`${SettingsApi.getAllUserGroup}`,params);
    return result.data;
}


export const saveUSergrp = async (params:saveUserGrpType[]):Promise<ResponseType<string | null>>=>{
    const result = await instance.post(`${SettingsApi.SaveUserGroup}`,params);
    return result.data;
}

export const deleteUserGrp = async (id:number):Promise<ResponseType<string | null>>=>{
    const result = await instance.delete(`${SettingsApi.deleteUserGroup}${id}`);
    return result.data;
}